import { Pipe, PipeTransform } from '@angular/core';
import { LessonPageItem } from '../../data/models/LessonPageItem';

@Pipe({
  name: 'filterTextType',
  standalone: true
})
export class FilterTextTypePipe implements PipeTransform {
 transform(items: LessonPageItem[] | null): LessonPageItem[] {
    if (!items) return [];
    return [...items.filter(item => item.type?.title === 'Text')];
  }
}
